import {Directive, EventEmitter, HostBinding, HostListener, Output} from '@angular/core';

@Directive({
    standalone: false,
    selector: '[fileDragDrop]'
})
export class FileDragNDropDirective
{
    //@Input() private allowed_extensions : Array<string> = ['png', 'jpg', 'bmp'];
    @Output() public filesChangeEmiter: EventEmitter<File[]> = new EventEmitter();
    //@Output() private filesInvalidEmiter : EventEmitter<File[]> = new EventEmitter();
    @HostBinding('class.file-drag-over') public isDragOver = false;

    @HostListener('dragover', ['$event'])
    public onDragOver(evt)
    {
        evt.preventDefault();
        evt.stopPropagation();
        this.isDragOver = true;
    }

    @HostListener('dragleave', ['$event'])
    public onDragLeave(evt)
    {
        evt.preventDefault();
        evt.stopPropagation();
        this.isDragOver = false;
    }

    @HostListener('drop', ['$event'])
    public onDrop(evt)
    {
        evt.preventDefault();
        evt.stopPropagation();
        this.isDragOver = false;
        this.filesChangeEmiter.emit(Array.from(evt.dataTransfer.files));
    }
}
